import { render, staticRenderFns } from "./shebeiM.vue?vue&type=template&id=ca54556c&scoped=true&"
import script from "./shebeiM.vue?vue&type=script&lang=js&"
export * from "./shebeiM.vue?vue&type=script&lang=js&"
import style0 from "./shebeiM.vue?vue&type=style&index=0&id=ca54556c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca54556c",
  null
  
)

export default component.exports